import { ActionReducerMap } from '@ngrx/store';
import { ConsentState } from './consent.state';
import { consent } from './reducers/consent.reducer';
import { enableConsentAuth } from './reducers/enable-consent-auth.reducer';
import { loadingError } from './reducers/loading-error.reducer';
import { loadingStatus } from './reducers/loading-status.reducer';

/**
 * Consent store.
 *
 * https://github.com/ngrx/platform/blob/master/docs/router-store/api.md#navigation-actions
 */
export const reducers: ActionReducerMap<ConsentState> = {
    consent,
    enableConsentAuth,
    loadingError,
    loadingStatus
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/consent.store.ts